import { GameCardConfiguration } from '../../gamesConfiguration';
import { step10talk } from './steps/10-talk';
import { step11sign } from './steps/11-sign';
import { step12talk } from './steps/12-talk';
import { step13talk } from './steps/13-talk';
import { step14stop } from './steps/14-stop';
import { step15talk } from './steps/15-talk';
import { step16riddle } from './steps/16-riddle';
import { step17riddle } from './steps/17-riddle';
import { step18riddle } from './steps/18-riddle';
import { step19riddle } from './steps/19-riddle';
import { step1intro } from './steps/1-intro';
import { step20talk } from './steps/20-talk';
import { step21bridge } from './steps/21-bridge';
import { step22talk } from './steps/22-talk';
import { step23road } from './steps/23-road';
import { step24bridge } from './steps/24-bridge';
import { step25talk } from './steps/25-talk';
import { step26door } from './steps/26-door';
import { step27door } from './steps/27-door';
import { step28door } from './steps/28-door';
import { step29door } from './steps/29-door';
import { step2coffeeShop } from './steps/2-coffeeshop';
import { step30talk } from './steps/30-talk';
import { step31church } from './steps/31-church';
import { step32talk } from './steps/32-talk';
import { step33church } from './steps/33-church';
import { step34tree } from './steps/34-tree';
import { step35tree } from './steps/35-tree';
import { step36end } from './steps/36-end';
import { step3bridge } from './steps/3-bridge';
import { step4vampireTalks } from './steps/4-vampiretalks';
import { step5underTheStairs } from './steps/5-understairs';
import { step6musketeer } from './steps/6-musketeer';
import { step7pond } from './steps/7-pond';
import { step8road } from './steps/8-road';
import { step9bench } from './steps/9-bench';
import gameBackground from '../../../assets/images/games/zdar-kids-game/game-preview.webp';

export const zdarKidsGameNumberSteps: number[] = [28, 29];
export const zdarKidsGameContentConfiguration: ZdarKidsGameConfiguration = {
    cardConfiguration: {
        title: 'Proč je Zelená Hora zelená?',
        subtitle: 'Dětská hra',
        background: gameBackground,
        gameUrl: '/detska-unikovka-zdar',
        showValidity: true,
    },
    gameConfiguration: [
        { points: false, id: 0 },
        step1intro,
        step2coffeeShop,
        step3bridge,
        step4vampireTalks,
        step5underTheStairs,
        step6musketeer,
        step7pond,
        step8road,
        step9bench,
        step10talk,
        step11sign,
        step12talk,
        step13talk,
        step14stop,
        step15talk,
        step16riddle,
        step17riddle,
        step18riddle,
        step19riddle,
        step20talk,
        step21bridge,
        step22talk,
        step23road,
        step24bridge,
        step25talk,
        step26door,
        step27door,
        step28door,
        step29door,
        step30talk,
        step31church,
        step32talk,
        step33church,
        step34tree,
        step35tree,
        step36end,
    ],
};

export type ZdarKidsGameCipher = {
    text?: string;
    images?: any[];
    custom?: any;
    label?: string;
    showSquiggle?: boolean;
};

export type ZdarKidsGameHint = {
    text?: string;
    image?: any;
    html?: string;
    solution?: boolean;
};

export type ZdarKidsGameStepConfiguration = {
    id: number;
    title?: string;
    taskText?: string;
    taskPreviewText?: string;
    audio?: any;
    codeInputText?: string;
    codeInputPassCodeRegexp?: string;
    additionalInfo?: string;
    hints?: ZdarKidsGameHint[];
    cipher?: ZdarKidsGameCipher;
    continueButtonText?: string;
    codeInputPassCodeCommonMistakeRegexp?: [string];
    codeInputPassCodeCommonMistakeMessage?: [string];
    points: boolean;
};

export type ZdarKidsGameGameConfiguration = ZdarKidsGameStepConfiguration[];

export type ZdarKidsGameConfiguration = {
    cardConfiguration: GameCardConfiguration;
    gameConfiguration: ZdarKidsGameGameConfiguration;
};
